exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "form[data-v-a4acb8d2]{display:flex;flex-direction:column;gap:10px}button[data-v-a4acb8d2]{padding:10px;background:#007bff;color:#fff;border:none;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a4acb8d2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/allModuleForm/transportEnq.vue
// module id = 1769
// module chunks = 0